import React from 'react';
import { Card, Button, Typography } from '../../../../../../components';
import './GetStartedCard.scss';
const { Title, Paragraph } = Typography;

/**
 * GetStartedCard - Card for Move Groups & Apps page
 */

export const GetStartedCard = ({ icon, title, text, className = '', onButtonClick, ...props }) => (
    <Card className={`move-groups-apps-card ${className}`} {...props}>
        <div className="move-groups-apps-card-header">
            <span className="move-groups-apps-card-icon">{icon}</span>
            <Title level={2} className="move-groups-apps-card-title">
                {title}
            </Title>
        </div>
        <div className="move-groups-apps-card-content">
            <Paragraph>{text}</Paragraph>
            <Button type="primary" shape="round" onClick={onButtonClick}>
                Get Started
            </Button>
        </div>
    </Card>
);
